import React, { Component } from 'react'
import ReactTable from 'react-table'
import { Button, Form, Modal, Popconfirm, Input, Upload, Icon, message, Spin, Tooltip } from 'antd'
import moment from 'moment'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Loader from '../../common/Loader'
import { actions as jobSiteTicketActions } from '../../../redux/modules/jobFunctions/jobSiteTicketActions'
import styled from 'styled-components'
import { filterCaseInsensitive } from '../../../util'

const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

const FormItem = Form.Item
const { TextArea } = Input
const propTypes = {}

class JobSiteTickets extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null
    }
  }

  componentWillMount() {
    this.props.jobTicketsRefresh({
      jobId: this.props.jobId
    })
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleRowClick = row => {
    this.props.getTicketAttachments({
      ticketId: row.id
    })
    this.setState({
      modalVisible: true,
      currentId: row.id,
      contentData: row
    })
  }

  handleAddButton = () => {
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      values.updated_by_id = this.props.user.userId
      values.updated_date = moment().format('YYYY/MM/DD HH:mm:ss')
      values.job_id = this.props.jobId

      if (this.state.currentId === 0) {
        values.created_by_id = this.props.user.userId
        values.created_date = moment().format('YYYY/MM/DD HH:mm:ss')

        this.props.createJobTicket({
          content: values,
          jobId: this.props.jobId
        })
        message.success('Ticket saved.')
      } else {
        this.props.updateJobTicket({
          jobId: this.props.jobId,
          ticketId: this.state.currentId,
          content: values
        })
        message.success('Changes saved.')
      }

      form.resetFields()
      this.setState({ contentData: null, currentId: 0, modalVisible: false })
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteJobTicket({
      jobId: this.props.jobId,
      ticketId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  handleVendorChange = event => {
    const form = this.props.form
    const selectedVendor = this.props.jobVendorActions.allVendors.data.filter(
      row => parseInt(row.id, 0) === parseInt(event, 0)
    )
    if (selectedVendor.length > 0) {
      form.setFieldsValue({
        requested_by: `${selectedVendor[0].created_by_first_name} ${
          selectedVendor[0].created_by_last_name
        }`,
        description: selectedVendor[0].description,
        work_order_template_id: selectedVendor[0].id
      })
    }
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'job_ticket')
    formData.append('created_by_id', this.props.user.userId)
    formData.append('updated_by_id', this.props.user.userId)
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('ticketId', this.state.currentId)

    this.props.uploadTicketAttachment({
      formData: formData,
      ticketId: this.state.currentId
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleUpdateAttachmentDescription = () => {
    this.props.updateTicketAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      ticketId: this.state.currentId,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteTicketAttachment({
      attachmentId: this.state.attachmentId,
      ticketId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  render() {
    const { contentData } = this.state

    const uploadProps = {
      multiple: true,
      fileList: this.state.fileList
    }

    const { getFieldDecorator } = this.props.form
    if (!this.props.jobSiteTicketActions.jobTickets) {
      return <Loader />
    }
    return (
      <div>
        <Modal
          visible={this.state.modalVisible}
          title="Ticket"
          okText={contentData ? 'Save Changes' : 'Create'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          maskClosable={false}
        >
          <Form layout="vertical">
            <div className="row">
              <div className="col-md-12">
                <FormItem label="Number">
                  {getFieldDecorator('name', {
                    rules: [
                      {
                        required: true,
                        message: 'Number cannot be empty.'
                      }
                    ],
                    initialValue: contentData ? contentData.name : ''
                  })(<Input />)}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <FormItem label="Description">
                  {getFieldDecorator('description', {
                    rules: [
                      {
                        required: true,
                        message: 'Description cannot be empty.'
                      }
                    ],
                    initialValue: contentData ? contentData.description : ''
                  })(<TextArea />)}
                </FormItem>
              </div>
            </div>
            {contentData && (
              <FilesUploadContainer>
                <div className="row">
                  <div className="col-md-6">
                    <h5>
                      <Icon type="file" /> Ticket Files
                    </h5>
                  </div>
                  <div className="col-md-6 text-right">
                    {this.props.jobSiteTicketActions &&
                      this.props.jobSiteTicketActions.uploadingAttachment && (
                        <div className="text-success">
                          <Icon type="loading" /> Uploading File(s)
                        </div>
                      )}
                    {this.props.jobSiteTicketActions &&
                      this.props.jobSiteTicketActions.deletingAttachment && (
                        <div className="text-danger">
                          <Icon type="loading" /> Deleting File(s)
                        </div>
                      )}
                  </div>
                </div>
                {this.props.jobSiteTicketActions.jobTicketsAttachments &&
                  this.props.jobSiteTicketActions.jobTicketsAttachments.data.length > 0 && (
                    <Spin spinning={this.props.jobSiteTicketActions.loadingAttachments}>
                      <ReactTable
                        defaultPageSize={5}
                        defaultFilterMethod={filterCaseInsensitive}
                        data={this.props.jobSiteTicketActions.jobTicketsAttachments.data}
                        getTrProps={(state, rowInfo, column, instance) => ({
                          onClick: e => this.handleAttachmentRowClick(rowInfo.original)
                        })}
                        columns={[
                          {
                            Header: 'Attached Files',
                            columns: [
                              {
                                Header: 'Filename',
                                id: 'filename',
                                accessor: 'filename',
                                Cell: d => (
                                  <Tooltip title={d.original.filename}>
                                    {d.original.filename}
                                  </Tooltip>
                                )
                              },
                              {
                                Header: 'Description',
                                id: 'description',
                                accessor: 'description',
                                Cell: d => (
                                  <Tooltip title={d.original.description}>
                                    {d.original.description}
                                  </Tooltip>
                                )
                              },
                              {
                                Cell: row => (
                                  <Tooltip placement="left" title="Open this file on a new window">
                                    <a target="_blank" href={row.original.signedUrl}>
                                      <Icon type="export" className="fontSize20" />
                                    </a>
                                  </Tooltip>
                                ),
                                maxWidth: 35
                              }
                            ]
                          }
                        ]}
                        defaultSorted={[
                          {
                            id: 'id',
                            desc: true
                          }
                        ]}
                        className="-striped -highlight"
                      />
                    </Spin>
                  )}
                {this.state.attachmentDetailsVisible && (
                  <EditAttachmentContainer>
                    <EditAttachmentTitle>
                      <Icon type="edit" /> Edit Attachment Area
                    </EditAttachmentTitle>
                    <div>
                      <EditingFileContainer>
                        <Icon type="file" /> {this.state.attachmentName}
                      </EditingFileContainer>
                    </div>
                    <div className="row">
                      <div className="col-md-10">
                        <TextArea
                          placeholder="Describe the attachment..."
                          rows={4}
                          onChange={this.onDescriptionChange}
                          value={this.state.attachmentDescription}
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-row mt-2">
                      <Button onClick={this.handleUpdateAttachmentDescription}>
                        <Icon type="save" /> OK
                      </Button>{' '}
                      <Popconfirm
                        title="Are you sure you want to delete this attachment?"
                        onConfirm={this.confirmAttachmentDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button type="danger" icon="delete" className="ml-2">
                          {' '}
                          DELETE
                        </Button>
                      </Popconfirm>
                    </div>
                  </EditAttachmentContainer>
                )}
                <br />
                <div>Upload Payment File(s)</div>
                <br />
                <Upload {...uploadProps} name="file" customRequest={this.uploadAttachment}>
                  <Button>
                    <Icon type="upload" /> Upload
                  </Button>
                </Upload>
              </FilesUploadContainer>
            )}
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {contentData && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
        <div className="jobsBar">
          Tickets
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD ticket
            </div>
          </div>
        </div>
        {this.props.jobSiteTicketActions.jobTickets && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={this.props.jobSiteTicketActions.jobTickets.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'ID',
                    accessor: 'id'
                  },
                  {
                    Header: 'Number',
                    id: 'name',
                    accessor: 'name',
                    Cell: d => <Tooltip title={d.original.name}>{d.original.name}</Tooltip>
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Created By',
                    id: 'created_by',
                    accessor: d => `${d.created_by_first_name} ${d.created_by_last_name}`,
                    Cell: d => {
                      const r = `${d.original.created_by_first_name} ${
                        d.original.created_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    },
                    width: 160
                  },
                  {
                    Header: 'Updated By',
                    id: 'updated_by',
                    accessor: d => `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                    Cell: d => {
                      const r = `${d.original.updated_by_first_name} ${
                        d.original.updated_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    },
                    width: 160
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: 'created_date',
                    Cell: row => <span>{moment.utc(row.value).format('M/D/YYYY')}</span>
                  }
                ]
              }
            ]}
            defaultSorted={[
              {
                id: 'id',
                desc: true
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ jobSiteTicketActions }, ownProps) => ({
  jobSiteTicketActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, jobSiteTicketActions), dispatch)
})

JobSiteTickets.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobSiteTickets))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteTickets.js